import { IUserDefinedItemSelectBehavior } from "./IUserDefinedItemSelectBehavior";

export interface IUserDefinedItemSelectBehaviorSpecifiable {
  userDefinedItemSelectBehavior: IUserDefinedItemSelectBehavior;
}

export function instanceOfIUserDefinedItemSelectBehaviorSpecifiable(instance: any): instance is IUserDefinedItemSelectBehaviorSpecifiable {
  return instance
    && (instance.userDefinedItemSelectBehavior !== undefined);
}
